module.exports = __webpack_public_path__ + "static/sf-partner-cegeka-7d7eaeaf3f567c6deea49dd3a4978aa0.jpg";